import { Collapse, Divider } from "antd"
import { useState } from "react"

const UMCCollapse = (props) => {

    const [activeKey, setActiveKey] = useState()

    const handleChange = (val) => {
        setActiveKey(val)
    }   

    return <Collapse
        activeKey={activeKey}
        expandIconPosition={"end"}
        onChange={handleChange}
        ghost
        items={[{
            key: "1",
            label: <Divider orientation="left" orientationMargin="0" plain style={{ margin: 0 }}>{props.label}</Divider>,
            children: props.children
        }]}
    />
}

export default UMCCollapse